// extracted by mini-css-extract-plugin
export default {"header":"vA","discountBanner":"wA","logo":"xA","maincontainer":"yA","videocontainer":"zA","videowelcome":"AA","videowrapper":"BA","videosale":"CA","loadingcontainer":"EA","footer":"FA","footerbutton":"GA","video":"HA","logoname":"IA"};
    if(module.hot) {
      // 1713809678201
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  